/* global axios */
import ApiClient from './ApiClient';

// Stages são sub-recurso de pipeline. Usamos 'pipelines' como resource raiz
// para reaproveitar `ApiClient#url` (resolve /api/v2/accounts/:id/pipelines)
// e nomeamos o builder específico como `urlFor(pipelineId)` para NÃO conflitar
// com o `baseUrl()` da superclasse - o conflito anterior quebrava o getter `url`.
class StagesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true, apiVersion: 'v2' });
  }

  urlFor(pipelineId) {
    return `${this.url}/${pipelineId}/stages`;
  }

  index(pipelineId) {
    return axios.get(this.urlFor(pipelineId));
  }

  create(pipelineId, payload) {
    return axios.post(this.urlFor(pipelineId), { stage: payload });
  }

  update(pipelineId, id, payload) {
    return axios.patch(`${this.urlFor(pipelineId)}/${id}`, { stage: payload });
  }

  destroy(pipelineId, id) {
    return axios.delete(`${this.urlFor(pipelineId)}/${id}`);
  }

  reorder(pipelineId, positions) {
    return axios.patch(`${this.urlFor(pipelineId)}/reorder`, { positions });
  }
}

export default new StagesAPI();
